import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace as replaceActionCreator } from 'react-router-redux';
import { selectUserIsAuthenticated } from '../../selectors/user';
import { selectAuthRequired } from '../../selectors/client';
import RedirectInstruction from '../../lib/routing/RedirectInstruction';

class AuthRequired extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    isAuthenticated: PropTypes.bool.isRequired,
    authRequired: PropTypes.bool,
    location: PropTypes.object.isRequired,
    replace: PropTypes.func.isRequired,
  };

  componentDidUpdate(prevProps) {
    if (!this.props.authRequired) {
      return;
    }

    if (prevProps.isAuthenticated && !this.props.isAuthenticated) {
      // User logged out while on a protected page — redirect to login
      const { location } = this.props;
      const to = `/${location.pathname}${location.search}`;
      this.props.replace(`/login?to=${encodeURIComponent(to)}`);
    }
  }

  render() {
    return this.props.children || null;
  }
}

// Static hook consumed by routeTransitionHook (server-side & client route transitions)
AuthRequired.onAccessFailure = function handleAccessFailure(store, params, location) {
  const state = store.getState();
  const authRequired = selectAuthRequired(state);

  if (!authRequired) {
    return null;
  }

  const isAuthenticated = selectUserIsAuthenticated(state);
  if (!isAuthenticated) {
    const to = `/${location.pathname}${location.search}`;
    return Promise.reject(new RedirectInstruction(`/login?to=${encodeURIComponent(to)}`));
  }
  return null;
};

export default connect(
  (state, ownProps) => ({
    isAuthenticated: selectUserIsAuthenticated(state),
    authRequired: selectAuthRequired(state),
    location: ownProps.location,
  }),
  {
    replace: replaceActionCreator,
  }
)(AuthRequired);
